/* THE switch for who reads delivery photos with AI (PEO-256): "aria" needs Core + Aria, "core"
   is every plan with Receiving. An override still decides for one organization. */
export const PHOTO_READER_SOLD_WITH = "core" as "aria" | "core";

export const PHOTO_READER =
  PHOTO_READER_SOLD_WITH === "aria"
    ? ({ module: "ai", follows: "ai-assistant" } as const)
    : ({ module: "core", follows: "pharmacy-receiving" } as const);
